import { BigWinProperties } from "@lib/js-slingo-pawnshop-core/dist";
export class BigWinLandscapeProperties extends BigWinProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
